<nav class="sticky top-0 z-30 w-full bg-white shadow-md border-t border-gray-200">
  <div class="flex items-center justify-between px-4 py-2">
    <div class="flex items-center">
      <button type="button" data-drawer-target="drawer-navigation" data-drawer-show="drawer-navigation"
        class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-secondary rounded-lg text-sm p-1.5 inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
        aria-controls="drawer-navigation">
        <svg class="w-[35px] h-[35px] text-secondary dark:text-white" aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M5 7h14M5 12h14M5 17h10" />
        </svg>
      </button>
      <a href="#" class="flex items-center ml-4 cursor-pointer">
        <img class="max-h-12" src="../../../assets/logo.png" loading="lazy" alt="Dashy logo" />
        <p class="text-secondary text-xl font-semibold ml-2.5"></p>
      </a>
      <a *ngIf="companyLogoUrl" href="#/administration/general-parameters"
        class="flex items-center ml-2 pl-4 cursor-pointer border-l border-gray-300">
        <img class="max-h-10" [src]="companyLogoUrl" loading="lazy" alt="Company logo" />
        <p class="text-secondary text-xl font-semibold ml-2.5"></p>
      </a>
    </div>

    <div class="flex items-center space-x-4">
      <div class="mx-2 border-r px-6 border-gray-300 w-40">
        <select [ngModel]="getCurrentLang()"
          class="bg-white border-none text-secondary text-sm rounded-full focus:ring-primary focus:border-primary p-2.5 w-full"
          aria-label="Select Language" (change)="changeLanguage($event)">
          <option value="fr">Français</option>
          <option value="en">English</option>
          <option value="ar">العربية</option>
        </select>
      </div>

      <!-- Notifications -->
      <div *ngIf="hasWhatsAppAccount" class="relative">
        <button #notificationToggle type="button" (click)="toggleNotifications()"
          class="notification-toggle-btn relative p-2 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-secondary rounded-lg text-sm inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white focus:outline-none transition-all">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
          </svg>
          <span *ngIf="unreadCount > 0"
            class="absolute top-1 right-1 inline-flex items-center justify-center px-1.5 py-0.5 text-[10px] font-black leading-none text-red-100 bg-red-600 rounded-full shadow-sm">{{
            unreadCount > 99 ? "99+" : unreadCount }}</span>
        </button>

      </div>
      <app-dropdown-user></app-dropdown-user>
    </div>
  </div>
</nav>

        <!-- Notification Dropdown -->
        <div *ngIf="hasWhatsAppAccount && showNotifications"
          class="notification-dropdown fixed bg-white rounded-xl shadow-2xl overflow-hidden z-[10000] border border-gray-100/50 backdrop-blur-md" [ngStyle]="notificationDropdownStyle">

          <!-- Dropdown Header -->
          <div class="bg-white/95 backdrop-blur-md border-b border-gray-100/50 sticky top-0 z-20">
            <div class="px-3.5 py-2.5 flex justify-between items-center">
              <h3 class="text-sm font-black text-gray-900 tracking-tight">
                {{ "NOTIFICATION.PAGE.TITLE" | translate }}
              </h3>
              <div class="flex items-center space-x-4">
                <label class="inline-flex items-center cursor-pointer group">
                  <input type="checkbox" [checked]="unreadOnly" (change)="toggleUnreadOnly()" class="sr-only peer">
                  <div
                    class="relative w-7 h-3.5 bg-gray-200 peer-focus:outline-none rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-200 after:border after:rounded-full after:h-2.5 after:w-2.5 after:transition-all peer-checked:bg-primary shadow-inner">
                  </div>
                  <span class="ms-1.5 text-[9px] font-bold text-gray-500 group-hover:text-primary transition-colors">
                    {{ "NOTIFICATION.PAGE.UNREAD_ONLY" | translate }}
                  </span>
                </label>
                <button (click)="openConfigModal()"
                  class="p-1 rounded-lg text-gray-400 hover:text-primary hover:bg-primary/5 transition-all duration-200 focus:outline-none border border-transparent hover:border-primary/10">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor" stroke-width="2.5">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </button>
              </div>
            </div>
            <div class="px-3.5 py-1.5 flex justify-end items-center border-t border-gray-50 bg-gray-50/20">
              <button (click)="markAllAsRead()" [disabled]="markingAllAsRead"
                class="text-[10px] text-primary hover:text-primary/70 font-black flex items-center space-x-2 disabled:opacity-50 transition-all uppercase tracking-widest">
                <svg *ngIf="!markingAllAsRead" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none"
                  viewBox="0 0 24 24" stroke="currentColor" stroke-width="3">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                </svg>
                <div *ngIf="markingAllAsRead" class="animate-spin rounded-full h-3 w-3 border-b-2 border-primary"></div>
                <span>{{ "NOTIFICATION.PAGE.MARK_ALL_READ" | translate }}</span>
              </button>
            </div>
          </div>

          <!-- Notification List (Scroll Area) -->
          <div class="max-h-[450px] overflow-y-auto bg-gray-50/50 p-2 space-y-2.5 custom-scrollbar">

            <div *ngFor="let notification of notifications" (click)="markAsRead(notification)"
              class="group relative rounded-xl shadow-sm border transition-all duration-300 p-3.5 cursor-pointer overflow-hidden"
              [ngClass]="{
                'bg-primary/[0.03] border-primary/20 ring-1 ring-primary/5 shadow-md': !notification.readStatus,
                'bg-white border-gray-100/80 grayscale-[0.3] opacity-90': notification.readStatus
              }">

              <!-- Left Side Active Bar -->
              <div *ngIf="!notification.readStatus"
                class="absolute left-0 top-1.5 bottom-1.5 w-1 rounded-r z-10"
                [ngClass]="notification.type === 'TICKET_MENTION'
                  ? 'bg-gradient-to-b from-violet-500 to-fuchsia-500 shadow-[2px_0_8px_rgba(139,92,246,0.35)]'
                  : 'bg-gradient-to-b from-primary to-blue-600 shadow-[2px_0_8px_rgba(59,130,246,0.3)]'">
              </div>

              <!-- Item Header -->
              <div class="flex items-center justify-between mb-2">
                <div class="flex items-center space-x-2">
                  <div
                    class="w-8 h-8 rounded-lg flex items-center justify-center shadow-inner transition-all group-hover:scale-110"
                    [ngClass]="{
                      'bg-blue-100 text-blue-600': !notification.readStatus && (notification.type === 'MESSAGE' || notification.type === 'TEXT'),
                      'bg-blue-50 text-blue-400': notification.readStatus && (notification.type === 'MESSAGE' || notification.type === 'TEXT'),
                      'bg-green-100 text-green-600': !notification.readStatus && (notification.type === 'TEMPLATE_APPROVED' || notification.type === 'CONTACT_UPLOAD_BATCH_FINISHED' || notification.type === 'BROADCAST_EXPORT_FINISHED'),
                      'bg-green-50 text-green-400': notification.readStatus && (notification.type === 'TEMPLATE_APPROVED' || notification.type === 'CONTACT_UPLOAD_BATCH_FINISHED' || notification.type === 'BROADCAST_EXPORT_FINISHED'),
                      'bg-red-100 text-red-600': !notification.readStatus && notification.type === 'TEMPLATE_REJECTED',
                      'bg-red-50 text-red-400': notification.readStatus && notification.type === 'TEMPLATE_REJECTED',
                      'bg-violet-100 text-violet-600': !notification.readStatus && notification.type === 'TICKET_MENTION',
                      'bg-violet-50 text-violet-400': notification.readStatus && notification.type === 'TICKET_MENTION',
                      'bg-gray-100 text-gray-500': !notification.type || notification.type === 'IMAGE' || notification.type === 'VIDEO' || notification.type === 'AUDIO' || notification.type === 'DOCUMENT'
                    }">
                    <ng-container [ngSwitch]="notification.type">
                      <svg *ngSwitchCase="'TEMPLATE_APPROVED'" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4"
                        fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      <svg *ngSwitchCase="'TEMPLATE_REJECTED'" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4"
                        fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      <svg *ngSwitchCase="'ORDER'" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none"
                        viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
                      </svg>
                      <svg *ngSwitchCase="'CONTACT_UPLOAD_BATCH_FINISHED'" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none"
                        viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                      </svg>
                      <svg *ngSwitchCase="'BROADCAST_EXPORT_FINISHED'" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none"
                        viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M12 3v12m0 0l-4-4m4 4l4-4M5 21h14" />
                      </svg>
                      <svg *ngSwitchCase="'TICKET_MENTION'" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4"
                        fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
                      </svg>
                      <svg *ngSwitchDefault xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none"
                        viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
                      </svg>
                    </ng-container>
                  </div>
                  <div>
                    <h4 class="text-[9px] font-black uppercase tracking-[0.05em] transition-colors duration-200"
                      [ngClass]="{
                        'text-primary': !notification.readStatus,
                        'text-gray-400': notification.readStatus
                      }">
                      {{ notification.type ? ("NOTIFICATION.TYPE." + notification.type | translate) : notification.title
                      }}
                    </h4>
                  </div>
                </div>
                <div class="flex flex-col items-end">
                  <span class="text-[8px] font-black text-gray-400 bg-gray-100/50 px-1.5 py-0.5 rounded-md">{{
                    notification.createdAt | date : "HH:mm" }}</span>
                </div>
              </div>

              <!-- Template Special Design -->
              <div *ngIf="notification.type === 'TEMPLATE_APPROVED' || notification.type === 'TEMPLATE_REJECTED'"
                class="space-y-2.5">
                <div class="flex items-center space-x-1.5">
                  <span class="text-[8px] font-bold text-gray-400">Nom :</span>
                  <span class="text-[10px] font-black uppercase transition-colors"
                    [ngClass]="{'text-primary': !notification.readStatus, 'text-gray-500': notification.readStatus}">{{
                    getTemplateName(notification.description) }}</span>
                </div>

                <!-- Preview Box -->
                <div class="bg-gray-50/30 rounded-lg border border-gray-100 p-3 shadow-sm">

                  <!-- Media Box -->
                  <div *ngIf="getTemplateHeaderType(notification.description)"
                    class="mb-3 bg-white rounded-md border border-dashed border-gray-100 p-3 gap-3 flex flex-col items-center justify-center group/media hover:border-primary/20 transition-all">
                    <div class="flex space-x-3 text-gray-200">
                      <div class="flex flex-col items-center space-y-1 w-20"
                           *ngIf="getTemplateHeaderType(notification.description) === 'IMAGE'"
                        [ngClass]="{'text-blue-500/30': getTemplateHeaderType(notification.description) === 'IMAGE'}">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7" fill="none" viewBox="0 0 25 25"
                          stroke="currentColor">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2"
                            d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                      </div>
                      <div class="flex flex-col items-center space-y-1 w-20"
                           *ngIf="getTemplateHeaderType(notification.description) === 'VIDEO'"
                        [ngClass]="{'text-red-500/30': getTemplateHeaderType(notification.description) === 'VIDEO'}">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7" fill="none" viewBox="0 0 24 24"
                          stroke="currentColor">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2"
                            d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                        </svg>
                      </div>
                      <div class="flex flex-col items-center space-y-1 w-20"
                           *ngIf="getTemplateHeaderType(notification.description) === 'DOCUMENT'"
                        [ngClass]="{'text-orange-500/30': getTemplateHeaderType(notification.description) === 'DOCUMENT'}">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7" fill="none" viewBox="0 0 24 24"
                          stroke="currentColor">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2"
                            d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                        </svg>
                      </div>
                    </div>
                  </div>

                  <!-- Text Content -->
                  <div class="text-[11px] leading-snug transition-all duration-300 overflow-hidden" [ngClass]="{
                      'line-clamp-3': !isExpanded(notification.id),
                      'max-h-none': isExpanded(notification.id),
                      'text-gray-900 font-bold': !notification.readStatus,
                      'text-gray-500 font-medium': notification.readStatus
                    }" [innerHTML]="getCleanTemplateContent(notification.description)">
                  </div>

                  <!-- Action Buttons -->
                  <div *ngIf="getTemplateButtons(notification.description).length > 0"
                    class="mt-3 flex flex-col space-y-1.5">
                    <div *ngFor="let btn of getTemplateButtons(notification.description)"
                      class="w-full py-2 bg-[#005a50] text-white text-[9px] font-black rounded-lg shadow-lg shadow-teal-900/10 flex items-center justify-center space-x-1.5 hover:bg-[#004d45] transition-all transform hover:-translate-y-0.5 active:scale-[0.98]">
                      <svg *ngIf="btn.type === 'PHONE_NUMBER'" xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5"
                        fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                      </svg>
                      <svg *ngIf="btn.type === 'URL'" xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" fill="none"
                        viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101" />
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M10.172 13.828a4 4 0 005.656 0l4-4a4 4 0 10-5.656-5.656l-1.101 1.101" />
                      </svg>
                      <span>{{ btn.text }}</span>
                    </div>
                  </div>

                  <!-- Expand Toggle -->
                  <div *ngIf="getCleanTemplateContent(notification.description).length > 150"
                    class="mt-3 flex justify-center pt-2 border-t border-gray-100/50">
                    <button (click)="toggleExpand($event, notification.id)"
                      class="px-4 py-1.5 bg-white hover:bg-gray-50 text-[9px] text-primary font-black rounded-full border border-gray-100 shadow-xl shadow-black/5 transition-all flex items-center space-x-1.5">
                      <span>{{ isExpanded(notification.id) ? 'RÉDUIRE' : 'VOIR PLUS' }}</span>
                      <svg xmlns="http://www.w3.org/2000/svg" class="h-2.5 w-2.5 transition-transform duration-300"
                        [ngClass]="{'rotate-180': isExpanded(notification.id)}" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor" stroke-width="3.5">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>

              <!-- Standard Item Body -->
              <div *ngIf="notification.type !== 'TEMPLATE_APPROVED'  && notification.type !== 'TEMPLATE_REJECTED'"
                class="mt-0.5">
                <p class="text-[11px] leading-tight transition-all duration-200 whitespace-pre-line" [ngClass]="{
                     'text-gray-900 font-bold': !notification.readStatus,
                     'text-gray-500 font-medium': notification.readStatus
                   }">
                  {{ getFormattedDescription(notification.description, notification.type) }}
                </p>

                <!-- Media Previews -->
                <div *ngIf="notification.mediaItems && notification.mediaItems.length > 0" class="mt-2.5 flex flex-wrap gap-2">
                  <div *ngFor="let item of notification.mediaItems" class="relative rounded-lg overflow-hidden border border-gray-100 bg-gray-50 flex items-center justify-center w-16 h-16 shadow-sm group/thumb">
                    <!-- Loader -->
                    <div *ngIf="item.loading" class="absolute inset-0 flex items-center justify-center bg-white/80">
                      <i class="fas fa-spinner fa-spin text-primary text-xs"></i>
                    </div>

                    <!-- Image -->
                    <img *ngIf="!item.loading && !item.error && item.mimeType?.startsWith('image/')" 
                         [src]="item.safeUrl" 
                         class="object-cover w-full h-full transition-transform duration-200 group-hover/thumb:scale-105" 
                         alt="Notification media" />

                    <!-- Document Icon -->
                    <div *ngIf="!item.loading && !item.error && !item.mimeType?.startsWith('image/')" class="flex flex-col items-center justify-center p-1 text-center w-full h-full bg-blue-50/30">
                      <i class="fas fa-file text-blue-500 text-lg mb-0.5"></i>
                      <span class="text-[8px] text-gray-500 truncate w-full px-1 font-semibold" [title]="item.fileName">{{ item.fileName }}</span>
                    </div>

                    <!-- Error state -->
                    <div *ngIf="item.error" class="flex items-center justify-center w-full h-full bg-red-50 text-red-500">
                      <i class="fas fa-circle-exclamation text-xs"></i>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Item Footer -->
              <div class="mt-3 pt-2 border-t border-gray-50 flex items-center justify-between">
                <div class="flex items-center space-x-1.5 group/date">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 text-gray-300 group-hover/date:text-primary"
                    fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                  <span class="text-[8px] font-black text-gray-400 uppercase tracking-widest">{{ notification.createdAt
                    | date: 'dd MMM yyyy' }}</span>
                </div>
                <div class="flex items-center space-x-2">
                  <div *ngIf="!notification.readStatus"
                    class="px-1.5 py-0.5 rounded-full bg-primary/10 border border-primary/20 text-primary text-[7px] font-black uppercase tracking-tight">
                    NOUVEAU</div>
                  <div class="w-1 h-1 rounded-full"
                    [ngClass]="notification.readStatus ? 'bg-gray-200' : 'bg-primary shadow-[0_0_12px_rgba(59,130,246,0.7)]'">
                  </div>
                </div>
              </div>
            </div>

            <!-- Empty State -->
            <div *ngIf="notifications.length === 0 && !loadingNotifications" class="py-24 text-center">
              <div
                class="inline-flex items-center justify-center w-24 h-24 rounded-full bg-gray-100/50 border border-gray-50 mb-6 group-hover:scale-110 transition-transform">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12 text-gray-300" fill="none" viewBox="0 0 24 24"
                  stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2"
                    d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0a2 2 0 01-2 2H6a2 2 0 01-2-2m16 0l-8 4-8-4" />
                </svg>
              </div>
              <p class="text-xs font-black text-gray-400 uppercase tracking-[0.3em]">{{ "NOTIFICATION.PAGE.EMPTY" |
                translate }}</p>
            </div>

            <!-- Page Load More -->
            <div *ngIf="notifications.length < totalElements && !loadingNotifications" class="pt-1">
              <button (click)="loadMoreNotifications($event)"
                class="w-full py-3 bg-white hover:bg-primary hover:text-white rounded-xl text-[9px] font-black text-primary border border-primary/10 shadow-lg shadow-black/5 hover:shadow-primary/20 transition-all uppercase tracking-[0.1em]">
                {{ "NOTIFICATION.PAGE.SHOW_MORE" | translate }}
              </button>
            </div>

            <div *ngIf="loadingNotifications" class="py-10 flex justify-center">
              <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
            </div>
          </div>
        </div>

<!-- Notification Config Modal -->
<div *ngIf="showConfigModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm"
  (click)="closeConfigModal()">
  <div class="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 overflow-hidden flex flex-col max-h-[85vh]"
    (click)="$event.stopPropagation()">

    <!-- Modal Header -->
    <div class="flex items-center justify-between px-4 py-3 border-b border-gray-100">
      <div class="flex items-center space-x-2">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-primary" fill="none" viewBox="0 0 24 24"
          stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
        <h2 class="text-sm font-bold text-gray-800">{{ "NOTIFICATION.CONFIG.TITLE" | translate }}</h2>
      </div>
      <button (click)="closeConfigModal()"
        class="p-1.5 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors focus:outline-none">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"
          stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
    <hr class="border-gray-200" />
    <div class="flex-1 overflow-y-auto px-4 py-3 bg-gray-50">
      <div *ngIf="loadingConfig" class="flex justify-center py-6">
        <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-primary"></div>
      </div>
      <div *ngIf="!loadingConfig">
        <p class="text-[10px] text-gray-400 font-bold mb-3 uppercase tracking-wider">{{ "NOTIFICATION.CONFIG.SUBTITLE" |
          translate }}</p>
        <div class="grid grid-cols-1 gap-2 bg-white p-3 border border-gray-100 rounded-lg">
          <div *ngFor="let type of allNotificationTypes"
            class="flex items-center justify-between px-3 py-2 rounded-lg border border-gray-50 bg-gray-50/30 transition-all duration-150"
            [ngClass]="{
              'border-primary/20 bg-white shadow-sm ring-1 ring-primary/5': isTypeEnabled(type)
            }">
            <div class="flex items-center space-x-2 min-w-0">
              <div class="w-1.5 h-1.5 flex-shrink-0 rounded-full" [ngClass]="{
                'bg-primary': isTypeEnabled(type),
                'bg-gray-300': !isTypeEnabled(type)
              }"></div>
              <span class="text-[11px] font-bold truncate transition-colors" [ngClass]="{
                'text-gray-900': isTypeEnabled(type),
                'text-gray-400': !isTypeEnabled(type)
              }">
                {{ "NOTIFICATION.TYPE." + type | translate }}
              </span>
            </div>
            <label class="inline-flex items-center cursor-pointer flex-shrink-0 ml-2">
              <input type="checkbox" [checked]="isTypeEnabled(type)" (change)="toggleType(type)" class="sr-only peer">
              <div
                class="relative w-7 h-3.5 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-2.5 after:w-2.5 after:transition-all peer-checked:bg-primary">
              </div>
            </label>
          </div>
        </div>
      </div>
    </div>
    <hr class="border-gray-200" />

    <!-- Modal Footer -->
    <div class="flex justify-end space-x-2 px-4 py-3 bg-white">
      <button (click)="closeConfigModal()" [disabled]="savingConfig"
        class="px-3 py-1.5 text-[10px] font-black text-gray-400 bg-white border border-gray-100 rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-50 uppercase tracking-widest">
        {{ "NOTIFICATION.CONFIG.CLOSE" | translate }}
      </button>
      <button (click)="saveConfig()" [disabled]="savingConfig || loadingConfig"
        class="px-4 py-1.5 text-[10px] font-black text-white bg-primary rounded-lg hover:bg-primary/90 transition-all disabled:opacity-50 flex items-center space-x-2 uppercase tracking-widest shadow-lg shadow-primary/20">
        <span>{{ "NOTIFICATION.CONFIG.SAVE" | translate }}</span>
      </button>
    </div>
  </div>
</div>
